import React from "react";
import { Progress } from "antd";
import { useTranslation } from "react-i18next";
import StarRating from "components/StarRating";
import { getStarRatingClasses } from "utils/Utils";

const AverageRatingDisplay = ({
  averageRating,
  feedbackRatingCount,
  totalCount,
}) => {
  const { t } = useTranslation();
  if (!averageRating) return null;

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm md:p-6">
      <div className="text-lg font-semibold text-gray-900">
        {t("Average Rating")}
      </div>
      <div className="mt-1 text-sm text-gray-500">
        {totalCount === 1
          ? t("Based on last 1 rating")
          : t("Based on last x ratings", {
              count: totalCount,
            })}
      </div>
      <div className="mt-5 flex flex-col gap-6 sm:flex-row sm:items-stretch sm:justify-between">
        <div className="min-w-0 flex-1 space-y-2">
          {feedbackRatingCount?.map((item, index) => (
            <div
              key={item?._id || index}
              className="flex items-center justify-between gap-3 rounded-xl border border-gray-100 bg-gray-50/80 px-3 py-2.5"
            >
              <StarRating
                className={`star ${getStarRatingClasses(item?.orderRating)}`}
                totalStars={5}
                rating={item?.orderRating}
                handleStarClick={() => {}}
                starContainerClassName="text-yellow-500"
              />
              <span className="shrink-0 text-sm text-gray-600">
                {item.count} {item?.count === 1 ? t("User") : t("Users")}
              </span>
            </div>
          ))}
        </div>
        <div className="flex shrink-0 items-center justify-center sm:ps-2">
          <Progress
            type="circle"
            percent={averageRating * 20}
            width={104}
            strokeWidth={6}
            format={() => (
              <div className="text-sm font-bold text-gray-900">
                {averageRating}
                <div className="mt-1 text-xs font-normal text-gray-500">
                  {t("out of 5")}
                </div>
              </div>
            )}
            strokeColor="#1890FF"
          />
        </div>
      </div>
    </div>
  );
};

export default AverageRatingDisplay;
